import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
// 导入 Ant Design 样式 - 必须在自定义样式之前
import 'antd/dist/reset.css'
import '@/shared/styles/variables.css'
// 导入自定义样式 - 覆盖 Ant Design 默认样式
import './index.css'

// 过滤第三方库的 React 警告
const originalConsoleError = console.error
console.error = (...args) => {
  const warningMessage = args[0]
  if (typeof warningMessage === 'string') {
    // 忽略第三方库的警告
    const shouldIgnore =
      // @uiw/react-md-editor 的 vAlign 警告
      warningMessage.includes('vAlign') ||
      warningMessage.includes('Warning: React does not recognize the') && warningMessage.includes('prop on a DOM element') ||
      // @uiw/react-md-editor 的 <term> 标签警告
      warningMessage.includes('The tag <term> is unrecognized') ||
      warningMessage.includes('is unrecognized in this browser') ||
      // @uiw/react-md-editor 的 colgroup 空白字符警告
      warningMessage.includes('validateDOMNesting') ||
      warningMessage.includes('Whitespace text nodes') && warningMessage.includes('colgroup') ||
      // Ant Design 的静态函数警告
      warningMessage.includes('Static function can not consume context')

    if (shouldIgnore) {
      return
    }
  }
  originalConsoleError.apply(console, args)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
